<template>
  <div class="derivatives-knowledge">
    <bCardHeader :param="param" class="card-header"></bCardHeader>
    <el-row class="m0">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="derivatives-knowledge-content card-base">
          <div class="page-title">
            {{ $t("tradeProduct.derivativesKnowledgeTitle") }}
          </div>
          <div class="derivatives-list" v-for="(item, index) in datalist" :key="index">
            <div class="question">{{ `${index + 1}. ${item.question}` }}</div>
            <div class="options">
              <div class="option" :class="{
                'correct-answer':
                  item.userAnswer === option.value &&
                  item.answer === option.value,
                'wrong-answer':
                  item.userAnswer === option.value &&
                  item.answer !== option.value,
              }" v-for="(option, oindex) in item.options" :key="oindex" @click="
                handleSelectOption(
                  index,
                  oindex,
                  option.value,
                  item.questionNumber
                )
                ">
                <span>{{ `${option.value}. ${option.label}` }}</span>
                <img class="icon" v-if="getIconSrc(item, option)" :src="getIconSrc(item, option)" alt="" srcset="" />
              </div>
            </div>
          </div>
          <div>
            <div class="footer-btn-group">
              <el-button type="primary" class="el-button-sub" @click="next">
                {{ $t('tradeProduct.btnReEvaluate') }}
              </el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import tradeApi from '@/api/v2/trade'
export default {
  data() {
    return {
      param: {
        title: 'trade_product',
        links: [
          {
            title: 'home'
          },
          {
            title: 'my_account'
          },
          {
            title: 'trade_product'
          }
        ]
      },
      selectedOptions: [],
      selectedAnswers: Array(10).fill(null),
      datalist: []
    }
  },
  async mounted() {
    await this.handeGetQuestionList()
  },
  methods: {
    getIconSrc(item, option) {
      if (item.userAnswer !== option.value) {
        return null
      }
      // 判断选项是否被选中
      const isSelected = item.userAnswer === option.value

      // 如果被选中，进一步判断是否正确
      if (isSelected) {
        return item.answer === option.value
          ? require('@/assets/images/correct.png') // 正确答案显示正确图标
          : require('@/assets/images/wrong.png') // 错误答案显示错误图标
      }
      return null
    },
    initData() {
      this.datalist = this.datalist.map(item => ({
        ...item,
        options: item.options.map(option => ({
          ...option,
          isSelected: false // 确保每个选项都有isSelected属性
        }))
      }))
    },
    async handeGetQuestionList() {
      tradeApi.getQuestionList().then(res => {
        if (res.code === 200) {
          this.datalist = res?.data || []
          this.initData()
        }
      })
    },
    async next() {
      this.$router.push('derivatives-knowledge')
    },
    handleSelectOption(index, oindex, value, questionNumber) {
      // 单选模式：重置所有选项，再设置当前选中
      this.datalist[index].options.forEach(option => {
        option.isSelected = false
      })
      this.$set(this.datalist[index].options[oindex], 'isSelected', true)
      this.$set(this.selectedAnswers, index, {
        questionNumber,
        answer: value
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.derivatives-knowledge {
  .derivatives-knowledge-content {
    padding: 24px;

    .page-title {
      font-size: 32px;
      color: #1c212a;
      font-weight: 600;
      margin-bottom: 32px;
    }

    .question {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: #1c212a;
      margin-bottom: 16px;
    }

    .options {
      .option {
        font-size: 14px;
        color: #1c212a;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px;
        &.selected {
          color: #4b596b;
        }

        &.correct-answer {
          background: rgba(247, 248, 250, 1);
        }

        &.wrong-answer {
          background: rgba(255, 77, 79, 0.1);
        }

        .icon {
          width: 18px;
          height: 18px;
          margin-left: auto;
        }
      }
    }

    .footer-btn-group {
      display: flex;
      align-items: center;
      gap: 12px;

      .el-button-sub {
        max-width: 250px;
      }
    }
  }
}
</style>
